import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { IAcaoPlanoAcaoModel, IPlanoAcaoModel } from "../../../models/plano-acao-model";
import { PlanoAcaoService } from "../../../services/plano-acao.service";
import { PlanoAcaoMonitorAvaliarAcaoComponent } from "../plano-acao-monitor-avaliar-acao/plano-acao-monitor-avaliar-acao.component";
import { PlanoAcaoMonitorMonitorarAcaoComponent } from "../plano-acao-monitor-monitorar-acao/plano-acao-monitor-monitorar-acao.component";
import { PlanoAcaoFormHistoricoAcaoComponent } from "../../plano-acao/plano-acao-form-preencher/plano-acao-form-historico-acao/plano-acao-form-historico-acao.component";
import { PlanoAcaoFormAcaoAvaliadaComponent } from "../../plano-acao/plano-acao-form/plano-acao-form-acao-avaliada/plano-acao-form-acao-avaliada.component";


@Component({
  selector: 'app-plano-acao-monitor-avaliar',
  templateUrl: './plano-acao-monitor-avaliar.component.html',
  styleUrls: ['./plano-acao-monitor-avaliar.component.scss']
})
export class PlanoAcaoMonitorAvaliarComponent implements OnInit, AfterViewInit {

  public id: number = 0;
  public dataSource = new MatTableDataSource<IAcaoPlanoAcaoModel>([]);
  public visualizar: boolean = false;
  public titulo: string = "";
  public podeFinalizar: boolean = false;
  public model: IPlanoAcaoModel = {} as IPlanoAcaoModel;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public matDialog: MatDialog,
    public servicePlanoAcao: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorAvaliarComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.id = data?.id || 0;
    this.visualizar = data?.visualizar || false;
    this.titulo = data?.titulo || '';
    this.podeFinalizar = data?.podeFinalizar;
  }

  ngOnInit(): void {
    this.buscar();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "identificador": return item?.identificador;
      case "titulo": return item?.titulo;
      case "prazo": return item?.prazo;
      case "avaliacao": return item?.avaliacao;
      case "responsavel": return item?.responsavelNome;
      case "status": return item?.status;
      default: return item[property];
    }
  };

  public buscar() {

    this.servicePlanoAcao
      .obterPorId(this.id)
      .then((res) => {

        if (res.sucesso) {

          this.model = res.dados;
          this.dataSource.data = this.model.acoes || [];

          this.cdr.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public modalAcao(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-avaliar-acao";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "180vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      planoAcaoId: this.model.id,
      unidadeGestoraId: this.model.unidadeGestoraId,
      osaExecucaoId: this.model.osaExecucaoId,
      element
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorAvaliarAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public modalAcaoAvaliada(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-visualizar-acao-avaliada";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "180vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      planoAcaoId: this.model.id,
      unidadeGestoraId: this.model.unidadeGestoraId,
      osaExecucaoId: this.model.osaExecucaoId,
      element
    };

    const modal = this.matDialog.open(PlanoAcaoFormAcaoAvaliadaComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }



  public finalizar() {

    Swal.fire({
      title: "Finalizar a Avaliação",
      text: "Tem certeza que deseja finalizar a avaliação?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        this.servicePlanoAcao
          .finalizarAvaliacao(this.id)
          .then((res) => {
            if (res.sucesso) {

              this.dialogRef.close(true);

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public modalMonitoramento(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-monitoramento";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "180vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      planoAcaoId: this.model.id,
      unidadeGestoraId: this.model.unidadeGestoraId,
      osaExecucaoId: this.model.osaExecucaoId,
      element
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorMonitorarAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public modalHistorico(element?: IAcaoPlanoAcaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-historico";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { id: element?.id, identificador: element?.identificador, idFuncionalidade: 41 };

    const modal = this.matDialog.open(PlanoAcaoFormHistoricoAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }  

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }





}
